import Button from "@/components/common/Button";
import Card from "@/components/common/Card";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

interface AccountSettingsProps {
  user: any;
}

const AccountSettings = ({ }: AccountSettingsProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="mb-6 text-xl font-semibold text-gray-900 dark:text-white">
        {t("settings.account")}
      </h2>

      <div className="space-y-6">
        {/* Profile Visibility */}
        <Card className="p-6">
          <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4">
            {t("settings.profileVisibility")}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            {t("settings.profileVisibilityDescription")}
          </p>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                {t("settings.makeProfilePublic")}
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {t("settings.makeProfilePublicDescription")}
              </p>
            </div>
            <Button variant="outline" size="sm">
              {t("settings.enable")}
            </Button>
          </div>
        </Card>

        {/* Delete Account */}
        <Card className="p-6 border-red-200 dark:border-red-800">
          <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4">
            {t("settings.deleteAccount")}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            {t("settings.deleteAccountDescription")}
          </p>
          <Button variant="outline" className="border-red-300 text-red-600 hover:bg-red-50 dark:border-red-700 dark:text-red-400 dark:hover:bg-red-900/20">
            {t("settings.deleteAccount")}
          </Button>
        </Card>
      </div>
    </motion.div>
  );
};

export default AccountSettings;

